import React from 'react';

function ChamadoSectorField({
    value,
    onChange,
    codSis,
    setCodSis,
    codEqp,
    setCodEqp,
    listSistemas = [],
    listaEquipamento = [],
    id = 'chamado-setor',
}) {
    return (
        <>
            <div className="chamado-create-field">
                <label htmlFor={id}>Setor</label>
                <select
                    id={id}
                    value={value}
                    onChange={(e) => {
                        onChange(e.target.value);
                        setCodSis('0');
                        setCodEqp('0');
                    }}
                >
                    <option value="">Selecione o setor...</option>
                    <option value="...">...</option>
                    <option value="I">Infraestrutura</option>
                    <option value="S">Sistemas</option>
                </select>
            </div>
            {value === 'S' && (
                <div className="chamado-create-field field-conditional">
                    <label htmlFor="chamado-sistema">Qual sistema?</label>
                    <select
                        id="chamado-sistema"
                        value={codSis}
                        onChange={(e) => {
                            setCodSis(e.target.value);
                            setCodEqp('0');
                        }}
                    >
                        <option value="0">Selecione</option>
                        {listSistemas.map((opt) => (
                            <option key={opt.codsis} value={opt.codsis}>
                                {opt.nomsis}
                            </option>
                        ))}
                    </select>
                </div>
            )}
            {value === 'I' && (
                <div className="chamado-create-field field-conditional">
                    <label htmlFor="chamado-equipamento">Qual equipamento?</label>
                    <select
                        id="chamado-equipamento"
                        value={codEqp}
                        onChange={(e) => {
                            setCodEqp(e.target.value);
                            setCodSis('0');
                        }}
                    >
                        <option value="">Selecione...</option>
                        {listaEquipamento.map((opt) => (
                            <option key={opt.codhar} value={opt.codhar}>
                                {opt.nomeqp} - {opt.sereqp} - {opt.pateqp}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </>
    );
}

export default ChamadoSectorField;
